<template>
    <div class="main">
        <el-dialog
            title="走访处理"
            :visible.sync="openData.state"
            :close-on-click-modal="false"
            width="70%"
            class="dialog_container"
            @close="dialogVisibleClone"
        >
            <ul class="infoUl">
                <li>
                    <p class="name">走访资源名称：</p>
                    <p class="text">{{ info.serviceTitle }}</p>
                </li>
                <li>
                    <p class="name">标准地址库：</p>
                    <p class="text">
                       {{ info.auditPassCount }}
                    </p>
                </li>
                <li>
                    <p class="name">所属网格：</p>
                    <p class="text">{{ info.upperLimit }}</p>
                </li>
            </ul>
            <el-form label-width="120px" :model="queryInfo">
                <div class="searchBox">
                    <div class="content">
                        <el-row>
                            <el-col :span="20">
                                <el-form-item label="走访日期" prop="recTime">
                                    <el-date-picker
                                        type="datetimerange"
                                        value-format="yyyy-MM-dd HH:mm:ss"
                                        format="yyyy-MM-dd HH:mm:ss"
                                        range-separator="至"
                                        style="width: 100%"
                                        v-model="queryInfo.recTime"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期"
                                        @change="recTimeChange"
                                    >
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="btn">
                        <el-button type="primary" @click="querySearch"
                            >查询</el-button
                        >
                        <el-button type="primary" @click="clearData"
                            >重置</el-button
                        >
                    </div>
                </div>
            </el-form>
            <el-button type="primary" @click="Export">导出Excel</el-button>
            <el-button type="success" @click="dialogVisibleClone"
                >返回</el-button
            >
            <div class="box">
                <el-table
                    :data="tableData"
                    tooltip-effect="dark"
                    style="width: 100%; margin: 15px 0"
                    border
                    ref="multipleTable"
                    height="250"
                    @selection-change="handleSelectionChange"
                >
                    <el-table-column
                        type="selection"
                        width="55"
                        align="center"
                    ></el-table-column>
                    <el-table-column
                        label="序号"
                        type="index"
                        align="center"
                        width="50"
                    ></el-table-column>
                    <el-table-column
                        prop="name"
                        align="center"
                        label="姓名"
                        width="100"
                        :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                        prop="personIdCard"
                        align="center"
                        label="身份证号"
                        width="150"
                        :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                        prop="age"
                        align="center"
                        label="年龄"
                        width="150"
                        :show-overflow-tooltip="true"
                    ></el-table-column>

                    <el-table-column
                        prop="phone"
                        align="center"
                        width="120"
                        label="手机号"
                        :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                        prop="sociologyOrgName"
                        align="center"
                        label="所属组织"
                        width="200"
                        :show-overflow-tooltip="true"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="signupDate"
                        align="center"
                        label="申请时间"
                        width="220"
                        :show-overflow-tooltip="true"
                    >
                    </el-table-column>

                    <el-table-column
                        prop="operation"
                        label="操作"
                        align="center"
                        width="120px"
                        fixed="right"
                    >
                        <template scope="scope"> </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    align="center"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    :current-page.sync="pageNo"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                    @size-change="handletableDataSize"
                    @current-change="handleTableDataChange"
                ></el-pagination>
            </div>
            <div slot="footer" class="dialog-footer dialog-footer-btn">
                <el-button type="primary" @click="handleSubmit"
                    >确 定</el-button
                >
                <el-button @click="dialogVisibleClone">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    props: ["openData"],
    data() {
        return {
            queryInfo: {},
            info: {
                serviceTitle: "",
                applicantsLimit: 0,
                upperLimit: 0,
                beginTime: "",
                endTime: "",
                preAuditCount: 0,
                auditPassCount: 0,
            },

            dialogFormVisible: false,
            seeVisible: false,
            lookPersonForm: {},
            visibleTitle: "",
            saveLoading: false,
            searchLoading: false,
            pageSize: 10,
            pageNo: 1,
            total: 0,
            chooseIds: [],
            chooseActive: [],
            chooseTimes: [],
            formData: {},
            tableData: [],
        }
    },
    created() {
        this.getList()
        this.getData()
        this.chooseIds = []
        this.chooseActive = []
        this.chooseTimes = []
    },

    methods: {
        // 关闭人员信息
        dialogVisibleClone() {
            // this.openData.state=false;
            this.$emit("cancleService", false)
        },
        //服务时间发生变化
        recTimeChange(val) {
            console.log(val)
            if (!val) return
            this.queryInfo.beginTime = val[0]
            this.queryInfo.endTime = val[1]
        },
        querySearch() {
            this.getList()
            this.getData()
        },
        // 间格式化
        renderTime(date) {
            var dates = new Date(date).toJSON()
            return new Date(+new Date(dates) + 8 * 3600 * 1000)
                .toISOString()
                .replace(/T/g, " ")
                .replace(/\.[\d]{3}Z/, "")
        },
        handleSubmit(){},
        // 获取详情
        getData() {
            const self = this
            let params = {
                id: self.openData.id,
            }
            this.$http
                .request({
                    url: "/sqyl/admin/fivelinkage/auditperson/info/getTopData",
                    method: "POST",
                    data: params,
                })
                .then(async (res) => {
                    if (res.code == 200) {
                        self.info = {
                            serviceTitle: res.content.serviceTitle,
                            applicantsLimit: res.content.applicantsLimit,
                            upperLimit: res.content.upperLimit,
                            beginTime: self.renderTime(res.content.beginTime),
                            endTime: self.renderTime(res.content.endTime),
                            preAuditCount: res.content.preAuditCount,
                            auditPassCount: res.content.auditPassCount,
                        }
                        // console.log(JSON.stringify(jsonTemp), "数据");
                    } else {
                        this.$message.error(res.message)
                    }
                })
        },

        handleTableForm(title, row) {
            this.chooseIds = []
            this.chooseActive = []
            this.chooseTimes = []
            this.visibleTitle = title
            this.dialogFormVisible = true
            this.seeVisible = false
            this.chooseIds.push(row.userId)
            this.chooseActive.push(row.serverActiveId)
            this.chooseTimes.push(row.signupDate)
        },
        // 导出
        Export() {
            this.request2({
                url: "/ypt/admin/fivelinkage/auditperson/info/downloadPersons",
                method: "POST",
                excel: true,
                data: {
                    id: this.openData.id,
                },
                responseType: "blob",
            }).then((res) => {
                if (res) {
                    const blob = new Blob([res], {
                        type: "application/vnd.ms-excel",
                    })
                    const fileName = "审核人员.xls"
                    const linkNode = document.createElement("a")
                    linkNode.download = fileName //a标签的download属性规定下载文件的名称
                    linkNode.style.display = "none"
                    linkNode.href = URL.createObjectURL(blob) //生成一个Blob URL
                    document.body.appendChild(linkNode)
                    linkNode.click() //模拟在按钮上的一次鼠标单击
                    URL.revokeObjectURL(linkNode.href) // 释放URL 对象
                    document.body.removeChild(linkNode)
                    this.$message.success("导出表格成功")
                } else {
                    this.$message.success("导出表格失败")
                }
            })
        },
        // 人员选择
        handleSelectionChange(rows) {
            // console.log(rows, "000");
            this.chooseIds = []
            this.chooseActive = []
            this.chooseTimes = []
            if (rows) {
                rows.forEach((row) => {
                    // this.$refs.multipleTable.toggleRowSelection(row);
                    this.chooseIds.push(row.userId)
                    this.chooseActive.push(row.serverActiveId)
                    this.chooseTimes.push(row.signupDate)
                })
            } else {
                this.$refs.multipleTable.clearSelection()
            }
        },
        // 获取表格数据
        getList() {
            let params = {
                id: this.openData.id,
                pageSize: this.pageSize,
                pageNo: this.pageNo,
            }
            this.$http
                .request({
                    url: "/sqyl/admin/fivelinkage/auditperson/info/auditPersons",
                    method: "POST",
                    data: params,
                })
                .then(async (res) => {
                    if (res.code == 200) {
                        if (res.content == null || res.content == "null") {
                            this.tableData = []
                            this.total = 0
                            return
                        }
                        if (res.content.list.length) {
                            res.content.list.forEach((item) => {
                                item.signupDate = this.renderTime(
                                    item.signupDate
                                )
                            })
                        }
                        this.tableData = res.content.list
                        this.total = res.content.count
                    } else {
                        this.$message.error(res.message)
                    }
                })
        },
        // 页面大小
        handletableDataSize(val) {
            this.pageSize = val
            this.getList()
        },
        // 当前页
        handleTableDataChange(val) {
            this.pageNo = val
            this.getList()
        },
        // 清空
        clearData() {
            this.pageSize = 10
            this.pageNo = 1
            this.total = 0
            this.tableData = []
            this.searchName = ""
            this.searchPhone = ""
            this.getList()
            this.getData()
        },

        // 关闭人员信息
        dialogClose() {
            this.seeVisible = false
            this.dialogFormVisible = false
        },
    },
}
</script>
<style lang="less" scoped>
.searchBox {
    display: flex;
    .content {
        flex: 1;
    }
}
.footer {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 15px;
}
.infoUl {
    display: flex;
    flex-flow: row wrap;
    box-sizing: border-box;
    justify-content: space-between;
    margin-bottom: 20px;

    li {
        width: calc((100% - 60px) / 3);
        line-height: 34px;
        display: flex;
        .name {
            width: 100px;
            text-align: right;
        }
        .text {
            flex: 1;
        }
    }
}
.box {
    margin: 25px 0;
}
/deep/.fontRed {
    color: red !important;
}
</style>